module.exports = __webpack_public_path__ + "static/media/footer-mobile.e5851a9e.png";